import { fromJS } from "immutable";
import TYPE from "../../constants/type";

const initialState = fromJS({
  list: [],
  listById: [],
  listFiltered: [],
  listDuplicate: [],
  isFetching: false,
  isFetchingAccepted: false,
});

export default function studentGuidanceReducer(state = initialState, action) {
  switch (action.type) {
    case TYPE.STUDENT_GUIDANCE.GET_ALL_STUDENT_GUIDANCE_LOADING:
    case TYPE.STUDENT_GUIDANCE.GET_FILTERED_STUDENT_GUIDANCE_LOADING:
    case TYPE.STUDENT_GUIDANCE.GET_ALL_STUDENT_GUIDANCE_BY_PROFILE_ID_LOADING:
    case TYPE.STUDENT_GUIDANCE.INSERT_STUDENT_GUIDANCE_LOADING:
    case TYPE.STUDENT_GUIDANCE.UPDATE_STUDENT_GUIDANCE_LOADING:
    case TYPE.STUDENT_GUIDANCE.DELETE_STUDENT_GUIDANCE_LOADING:
    case TYPE.STUDENT_GUIDANCE.EXPORT_STUDENT_GUIDANCE_LOADING:
    case TYPE.STUDENT_GUIDANCE.CHECK_DUPLICATE_STUDENT_GUIDANCE_LOADING:
      return state.merge({
        isFetching: true,
      });

    case TYPE.STUDENT_GUIDANCE.ACCEPT_STUDENT_GUIDANCE_LOADING:
      return state.merge({
        isFetchingAccepted: true,
      });

    case TYPE.STUDENT_GUIDANCE.GET_ALL_STUDENT_GUIDANCE_FAILURE:
    case TYPE.STUDENT_GUIDANCE.GET_FILTERED_STUDENT_GUIDANCE_FAILURE:
    case TYPE.STUDENT_GUIDANCE.GET_ALL_STUDENT_GUIDANCE_BY_PROFILE_ID_FAILURE:
    case TYPE.STUDENT_GUIDANCE.INSERT_STUDENT_GUIDANCE_FAILURE:
    case TYPE.STUDENT_GUIDANCE.UPDATE_STUDENT_GUIDANCE_FAILURE:
    case TYPE.STUDENT_GUIDANCE.DELETE_STUDENT_GUIDANCE_FAILURE:
    case TYPE.STUDENT_GUIDANCE.EXPORT_STUDENT_GUIDANCE_FAILURE:
    case TYPE.STUDENT_GUIDANCE.CHECK_DUPLICATE_STUDENT_GUIDANCE_FAILURE:
      return state.merge({
        isFetching: false,
      });

    case TYPE.STUDENT_GUIDANCE.ACCEPT_STUDENT_GUIDANCE_FAILURE:
      return state.merge({
        isFetchingAccepted: false,
      });

    case TYPE.STUDENT_GUIDANCE.GET_ALL_STUDENT_GUIDANCE_SUCCESS:
      return state.merge({
        isFetching: false,
        list: action.payload,
      });

    case TYPE.STUDENT_GUIDANCE.GET_FILTERED_STUDENT_GUIDANCE_SUCCESS:
      return state.merge({
        isFetching: false,
        listFiltered: action.payload,
      });

    case TYPE.STUDENT_GUIDANCE.GET_ALL_STUDENT_GUIDANCE_BY_PROFILE_ID_SUCCESS:
      return state.merge({
        isFetching: false,
        listById: action.payload,
      });

    case TYPE.STUDENT_GUIDANCE.INSERT_STUDENT_GUIDANCE_SUCCESS:
      return state.merge({
        isFetching: false,
        listById: state.get("listById").push(action.payload),
        list: state.get("list").push(action.payload),
      });

    case TYPE.STUDENT_GUIDANCE.UPDATE_STUDENT_GUIDANCE_SUCCESS: {
      const indexById = state.get("listById").findIndex((item) => item.id === action.id);
      const indexList = state.get("list").findIndex((item) => item.id === action.id);
      const indexFiltered = state.get("listFiltered").findIndex((item) => item.id === action.id);

      let newState = state;
      if (indexById !== -1) {
        newState = newState.setIn(["listById", indexById], action.payload);
      }
      if (indexList !== -1) {
        newState = newState.setIn(["list", indexList], action.payload);
      }
      if (indexFiltered !== -1) {
        newState = newState.setIn(["listFiltered", indexFiltered], action.payload);
      }

      return newState.merge({ isFetching: false });
    }

    case TYPE.STUDENT_GUIDANCE.DELETE_STUDENT_GUIDANCE_SUCCESS: {
      const newListById = state.get("listById").filter((item) => item.id !== action.payload);
      const newList = state.get("list").filter((item) => item.id !== action.payload);

      return state.merge({
        isFetching: false,
        listById: newListById,
        list: newList,
      });
    }

    case TYPE.STUDENT_GUIDANCE.ACCEPT_STUDENT_GUIDANCE_SUCCESS: {
      const indexById = state.get("listById").findIndex((item) => item.id === action.payload.id);
      const indexList = state.get("list").findIndex((item) => item.id === action.payload.id);

      let newState = state;
      if (indexById !== -1) {
        newState = newState.setIn(["listById", indexById], action.payload);
      }
      if (indexList !== -1) {
        newState = newState.setIn(["list", indexList], action.payload);
      }

      return newState.merge({ isFetchingAccepted: false });
    }

    case TYPE.STUDENT_GUIDANCE.EXPORT_STUDENT_GUIDANCE_SUCCESS:
      return state.merge({
        isFetching: false,
      });

    case TYPE.STUDENT_GUIDANCE.CHECK_DUPLICATE_STUDENT_GUIDANCE_SUCCESS:
      return state.merge({
        listDuplicate: action.payload || [],
        isFetching: false,
      });

    default:
      return state;
  }
}

